import { CONSTANT } from "./constant"
import { _getValue } from "./common"

export const offerTabItems = [
  {
    id: "offer-general",
    path: CONSTANT.ROUTE.NAME.SALES_FORCE_OFFER_EDIT_GENERAL,
    name: "eecom-teamportal.offering.tabs.general",
  },
]

export const getCustomizationLabel = (stockProduct: any) => {
  if (stockProduct.options && stockProduct.options.length > 0) {
    return stockProduct.options[0].name || stockProduct.options[0].translated.name
  } else {
    return stockProduct.productNumber
  }
}

export const offerDBName = CONSTANT.INDEX_DB.NAME.OFFER_PLAYER_CONFIGURATION
export const offerDBVersion = CONSTANT.INDEX_DB.VERSION.OFFER_PLAYER_CONFIGURATION
export const offerConfigDBStoreName = CONSTANT.INDEX_DB.OBJECT_STORE.NAME.OFFER_ASSORTMENT_ITEM
export const offerConfigDBStoreOptions = CONSTANT.INDEX_DB.OBJECT_STORE.OPTIONS.DEFAULT

export const OFFER_STATE = {
  NOT_FULLY_CONFIGURED: "not_fully_configured",
  OPEN: "open",
  BUYABLE: "buyable",
  BOUGHT: "bought",
} as const

export const getDerivedOfferState = (offerData: any, getProductValidity: (product: any) => { totalQty: number }): string => {
  if (!offerData?.eecomTpAssortment?.eecomTpAssortmentProducts?.length) {
    return OFFER_STATE.NOT_FULLY_CONFIGURED
  }

  const allConfigured = (offerData?.eecomTpAssortment?.eecomTpAssortmentProducts || []).every((product: any) => {
    const configuration = _getValue(product, "configuration", false).value
    if (!configuration) return false

    const { totalQty } = getProductValidity(product)
    return totalQty > 0
  })

  const hasBillingAddress = !!offerData.billingAddressId || !!offerData.billingAddressSnapshot
  const hasShippingAddress = !!offerData.shippingAddressId || !!offerData.shippingAddressSnapshot
  const hasAddressesAndPayment = hasBillingAddress && hasShippingAddress && !!offerData.paymentMethodId

  return allConfigured && hasAddressesAndPayment ? OFFER_STATE.OPEN : OFFER_STATE.NOT_FULLY_CONFIGURED
}

export const getOfferProductPosition = (product: any): number => {
  const configs = product?.eecomTpOfferAssortmentProductConfigs || []
  if (configs.length === 0) {
    return Number.MAX_SAFE_INTEGER
  }
  return Math.min(...configs.map((config: any) => config?.position ?? Number.MAX_SAFE_INTEGER))
}

export const sortOfferProductsByPosition = (products: any[]): any[] => {
  if (!Array.isArray(products) || products.length === 0) {
    return []
  }
  return [...products].sort((a, b) => getOfferProductPosition(a) - getOfferProductPosition(b))
}
